import {IViewType, IViewTypeV4} from './type';
import {ISendEventParam, sendEvent} from '../common/util/tracking';

const TRACKING_PAGE_NAME: {[key in IViewType]: string} = {
  initialView: 'search_home',
  searchView: 'search_box',
  resultView: 'search_result',
};
const TRACKING_PAGE_NAME_V4: {[key in IViewTypeV4]: string} = {
  searchView: 'search_home',
  resultView: 'search_result',
};

export function sendSearchEvent(
  viewType: IViewType,
  params: Pick<ISendEventParam, 'actionName' | 'action' | 'customProps'>
) {
  sendEvent({
    section: 'search',
    page: TRACKING_PAGE_NAME[viewType],
    ...params,
  });
}

export function sendSearchEventV4({
  viewType,
  ...params
}: {viewType: IViewTypeV4} & Pick<
  ISendEventParam,
  'actionName' | 'customProps'
>) {
  sendEvent({
    section: 'search',
    page: TRACKING_PAGE_NAME_V4[viewType],
    action: 'click',
    ...params,
  });
}

export function getSearchCustomProps(keyword: string, totalCount: number) {
  return {
    search_keyword: keyword,
    search_result_count: totalCount,
    search_type: keyword[0] === '#' ? 'genre_search' : 'total_search',
  };
}
